<template>
  <div class="charge-api-list" v-loading="loading">
    <div class="head_body">
      <el-form ref="form" :model="pageInfo" class="search_head">
        <el-row :gutter="20" class="list-head">
          <el-col :span="4">
            <el-form-item :label="$t('charge.pile_code')">
              <el-input v-model="pageInfo.pileCode" :placeholder="$t('charge.please_pile_code')" clearable/>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item :label="$t('charge.status')">
              <el-select
                clearable
                :placeholder="$t('charge.status')"
                v-model="pageInfo.status"
                style="width: 100%"
              >
                <el-option key="all" :label="$t('control.all')" value=""></el-option>
                <el-option
                  v-for="(t,index) in status_arr"
                  :key="index"
                  :label="t"
                  :value="index"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="2" class="search-btn-box">
              <el-button type="primary" size="small" @click="headSearch"><svg-icon name="search"></svg-icon>{{$t('control.search')}}</el-button>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class="h_line"></div>
    <div class="con-body">
      <div class="control-group">
        <div class="group-left">
          <el-button
            type="primary"
            size="small"
            @click="openEditWin('create')"
            class="insert-btn"
            ><svg-icon name="add-plus"></svg-icon>{{$t('control.add')}}</el-button>
            <el-alert
              :title="$t('charge.click_arrow')"
              type="warning"
              :closable="false"
              show-icon>
            </el-alert>
        </div>
      </div>
      <el-table
        class="normal-table"
        :preserve-expanded-content="true"
        :data="tableData"
        row-key="id"
        :expand-row-keys="allExpandKeys"
        style="width: 100%"
        :empty-text="$t('system.no_data')"
      >
        <el-table-column type="expand">
          <template slot-scope="props">
            <div class="sub-table-pad">
              <el-table class="sub-table" :data="props.row.guns" :empty-text="$t('charge.no_gun')" :border="true" style="width: 100%;">
                <el-table-column :label="$t('charge.gun_no')">
                  <template slot-scope="scope">
                    <span style="font-weight: bold;">{{scope.row.gunNo}}</span>
                  </template>
                </el-table-column>
                <el-table-column :label="$t('charge.last_heartbeat')" prop="lastStateAt" />
                <el-table-column :label="$t('charge.docked_flag')">
                  <template slot-scope="scope">
                    <span v-if="scope.row.dockedFlag === null||scope.row.dockedFlag === ''||scope.row.dockedFlag === undefined">{{ flag_arr[scope.row.dockedFlag||0] }}</span>
                    <span v-else>{{ $t('charge.unknown') }}</span>
                  </template>
                </el-table-column>
                <el-table-column :label="$t('charge.plugged_flag')">
                  <template slot-scope="scope">
                    <span v-if="scope.row.pluggedFlag === null||scope.row.pluggedFlag === ''||scope.row.pluggedFlag === undefined">{{ flag_arr[scope.row.pluggedFlag||0] }}</span>
                    <span v-else>{{ $t('charge.unknown') }}</span>
                  </template>
                </el-table-column>
                <el-table-column width="160" :label="$t('charge.status')">
                  <template slot-scope="scope">
                    <div v-if="scope.row.status===null||scope.row.status===''||scope.row.status===undefined">
                      <span class="grey">{{$t('charge.unknown')}}</span>
                    </div>
                    <div v-else>
                      <i :class="scope.row.status===0||scope.row.status==='0'?'valuegrey':'valuegreen'"></i>
                      <span>{{ status_arr[scope.row.status||0] }}</span>
                    </div>
                  </template>
                </el-table-column>

                <el-table-column :label="$t('charge.start')">
                  <template slot-scope="scope">
                    <span class="pointer blue" @click="gunSet(props.row.pileCode, scope.row, 1)">{{$t('charge.remote_start')}}</span>
                  </template>
                </el-table-column>

                <el-table-column :label="$t('charge.stop')">
                  <template slot-scope="scope">
                    <span class="pointer blue" @click="gunSet(props.row.pileCode, scope.row, 0)">{{$t('charge.remote_stop')}}</span>
                  </template>
                </el-table-column>

              </el-table>
            </div>
          </template>
        </el-table-column>
        <el-table-column :label="$t('charge.location')">
          <template slot-scope="scope">
            <span>{{scope.row.location||'-'}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="pileCode" :label="$t('charge.pile_code')" />
        <el-table-column prop="pileType" :label="$t('charge.pile_type')">
          <template slot-scope="scope">
            <span>{{ pile_type_arr[scope.row.pileType||0] }}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('charge.gun_count')">
          <template slot-scope="scope">
            <span>{{ scope.row.guns.length||0 }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="progVer" :label="$t('charge.prog_ver')" />
        <el-table-column prop="protocolVer" :label="$t('charge.protocol_ver')" />
        <el-table-column :label="$t('charge.last_heartbeat')" prop="lastHeartbeatAt" />
        
        <el-table-column width="160" :label="$t('charge.status')">
          <template slot-scope="scope">
            <div v-if="scope.row.status===null||scope.row.status===''||scope.row.status===undefined">
              <span class="grey">{{$t('charge.unknown')}}</span>
            </div>
            <div v-else>
              <i :class="scope.row.status===0||scope.row.status==='0'?'valuegrey':'valuegreen'"></i>
              <span>{{ status_arr[scope.row.status||0] }}</span>
            </div>
          </template>
        </el-table-column>

        <el-table-column fixed="right" :label="$t('control.operate')" width="100" align="center">
          <template slot-scope="scope">
            <div class="edit-button">
              <i
                @click="openEditWin(scope.row)"
                class="el-icon-edit pointer mar-r10"
              ></i>
              <i
                class="el-icon-delete pointer"
                @click="delItem(scope.row.id)"
              ></i>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageInfo.page"
        :page-sizes="[10, 20, 30, 40, 50, 100]"
        :page-size="pageInfo.pageSize"
        layout="sizes, total, prev, pager, next, jumper"
        :total="cnt_all"
      >
      </el-pagination>
    </div>
    <!--新增对话框-->
    <el-dialog
      v-if="dialogVisible"
      custom-class="mw-edit-dialog"
      class="dialog600"
      :title="editType === 'create' ? $t('control.add') : $t('control.edit')"
      :visible.sync="dialogVisible"
    >
      <el-form
        :model="editOne"
        label-position="left"
        :rules="editOneRule"
      >
        <div class="form-info">
          <el-form-item :label="$t('charge.location')" prop="location">
            <el-input v-model="editOne.location" :placeholder="$t('charge.please_location')"></el-input>
          </el-form-item>
          <el-form-item :label="$t('charge.pile_code')" prop="pileCode">
            <el-input v-model="editOne.pileCode" :placeholder="$t('charge.please_pile_code')"></el-input>
          </el-form-item>
          <el-form-item :label="$t('charge.gun_count')" prop="gunCount">
            <el-input-number v-model="editOne.gunCount" :min="1" :max="100"></el-input-number>
          </el-form-item>
          <el-form-item :label="$t('charge.pile_type')" prop="pileType">
            <el-select v-model="editOne.pileType" :placeholder="$t('charge.please_pile_type')">
              <el-option
                v-for="(t, index) in filteredPileTypeArr"
                :key="index + 1"
                :label="t"
                :value="index + 1"
              />
            </el-select>
          </el-form-item>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button class="mw-edit-button" @click="dialogVisible = false"
          >{{$t('control.cancel')}}</el-button
        >
        <el-button
          type="primary"
          @click="createItem"
          v-if="editType === 'create'"
          >{{$t('control.confirm')}}</el-button
        >
        <el-button
          type="primary"
          @click="updateItem"
          v-if="editType === 'update'"
          >{{$t('control.confirm')}}</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import chargeApi from "@/api/chargeApi/list";
export default {
  data() {
    return {
      loading: false,
      dialogVisible: false,
      status_arr: this.$t('charge.status_arr'),
      flag_arr: this.$t('charge.flag_arr'),
      pile_type_arr: this.$t('charge.pile_type_arr'),
      tableData: [],
      pageInfo: {
        pileCode: '',
        status: '',
        page: 1,
        pageSize: 50,
      },
      cnt_all: 0,
      editOneRule: {
        pileCode: [{ required: true, message: this.$t('charge.please_pile_code'), trigger: "blur" }],
        location: [{ required: true, message: this.$t('charge.please_location'), trigger: "blur" }]
      },
      editType: -1,
      devSelect: [],
      editOne: {
        id: '',
        pileCode: '',
        location: '',
        gunCount: 1,
        pileType: 1
      }
    };
  },
  computed: {
    filteredPileTypeArr() {
      return this.pile_type_arr.slice(1);
    },
    allExpandKeys() {
      return this.tableData.map(item => item.id);
    }
  },
  methods: {
    getTableData(pageIndex) {
      this.pageInfo.page = pageIndex;
      this.loading = true;
      chargeApi.dataList(this.pageInfo).then((res) => {
        console.log('dataList', res.data.data)
        if (res.data.code === 1000) {
          this.loading = false;
          let resData = res.data.data;
          this.tableData = resData.list;
          this.pageInfo.page = pageIndex;
          this.cnt_all = resData.list.length;
        }
      });
    },
    headSearch() {
      this.pageInfo.page = 1
      this.pageInfo.pageSize = 20
      this.getTableData(1)
    },
    handleSizeChange(val) {
      this.pageInfo.pageSize = val;
      this.getTableData(this.pageInfo.page);
    },
    handleCurrentChange(val) {
      this.pageInfo.page = val;
      this.getTableData(this.pageInfo.page);
    },

    gunSet(pileCode, row, cmd) {
      const { status, gunNo } = row
      if (!status||status==='0') {
        this.$message.error(this.$t('charge.gun_offline'));
        return;
      }
      this.$confirm(this.$t(cmd===1? 'charge.remote_start' : 'charge.remote_stop'), this.$t('control.tip'), {
        confirmButtonText: this.$t('control.confirm'),
        cancelButtonText: this.$t('control.cancel'),
        type: "warning"
      })
        .then(() => {
          if(cmd===1){
            chargeApi.remoteStart({
              pileCode,
              gunNo
            }).then((res) => {
              if (res.data.code === 1000) {
                this.$message.success(this.$t('charge.remote_start_success'));
                this.getTableData(this.pageInfo.page);
              } else {
                this.$message.error(res.data.message);
              }
            });
          }else{
            chargeApi.remoteStop({
              pileCode,
              gunNo
            }).then((res) => {
              if (res.data.code === 1000) {
                this.$message.success(this.$t('charge.remote_stop_success'));
                this.getTableData(this.pageInfo.page);
              } else {
                this.$message.error(res.data.message);
              }
            });
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: this.$t('control.cancel_del')
          });
        });
    },

    openEditWin(index) {
      if (index === "create") {
        this.editOne = {
          pileCode: '',
          location: '',
          gunCount: 1,
          pileType: 1
        };
        this.editType = "create";
      } else { 
		    this.editOne = {
          id: index.id,
          pileCode: index.pileCode,
          location: index.location,
          gunCount: index.gunCount,
          pileType: index.pileType
        };
        this.editType = "update";
      }
      this.dialogVisible = true;
    },

    updateItem() {
      chargeApi.dataEdit(this.editOne).then((res) => {
        if (res.data.code === 1000) {
          this.dialogVisible = false;
          this.$message.success(this.$t('control.mod_success'));

          this.getTableData(this.pageInfo.page);
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    createItem() {
      const postParams = { ...this.editOne };
      delete postParams.id;
      chargeApi.dataAdd(postParams).then((res) => {
        if (res.data.code === 1000) {
          this.$message.success(this.$t('control.add_success'));
          this.dialogVisible = false;
          this.getTableData(this.pageInfo.page);
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    delItem(id) {
      this.$confirm(this.$t('control.tip_del_data_title'), this.$t('control.tip'), {
        confirmButtonText: this.$t('control.confirm'),
        cancelButtonText: this.$t('control.cancel'),
        type: "warning"
      })
        .then(() => {
          chargeApi.dataDel(id).then((res) => {
            if (res.data.code === 1000) {
              this.$message.success(this.$t('control.del_success'));
              this.getTableData(this.pageInfo.page);
            } else {
              this.$message.error(res.data.message);
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: this.$t('control.cancel_del')
          });
        });
    }
  },
  mounted() {
    this.getTableData(this.pageInfo.page);
  },
};
</script>
<style lang='less'>
.charge-api-list {
  width: 100%;
  .form-info{
    padding-left: 10px;
    .el-form-item__label{
      width:85px;
    }
  }
}
</style>